<div
  class="work-time-indicator dropdown"
  dropdown
  #dropdown="bs-dropdown"
  [insideClick]="true"
  [autoClose]="false"
  *ngIf="tasEnabled"
>
  <div
    class="col-auto gutter-xs"
    *ngIf="[1,3].includes(tasStatus)"
    [style.color]="getTasColor()"
    dropdownToggle
  >
    <div class="current-time-indicator">
      <i class="mr-1 fal fa-clock fa-lg text-shadow"></i>

      <div class="current-duration-indicator">
        <div class="current-duration">
          <span class="font-xl text-shadow">{{
            duration$ | async | durationPipe
          }}</span>
        </div>
        <div class="current-time-label">
          <span class="font-s text-muted" *ngIf="tasStatus == 3">{{
            breakName
          }}</span>
          <span class="text-muted current-time-label" *ngIf="((costCentreID$ | async) && costCentreEnabled )  &&tasStatus == 1">{{
            costCentreName$ | async
          }}</span>
          <span class="text-muted current-time-label" *ngIf="!((costCentreID$ | async) && costCentreEnabled )  &&tasStatus == 1">{{
            "work_time.shift_active" | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>
  <div
    class="col-auto gutter-xs"
    *ngIf="![1,3].includes(tasStatus)"
    [style.color]="getTasColor()"
    dropdownToggle
  >
    <div class="current-time-indicator">
      <i class="mr-1 fal fa-clock fa-lg text-shadow"></i>

      <div class="current-duration-indicator">
        <div class="current-duration">
          <span class="font-xl text-shadow" *ngIf="tasStatus == 0">
            {{
            'work_time.shift_inactive' | translate
          }}</span>
          <span class="font-xl text-shadow" *ngIf="tasStatus == 2">
            {{
            'work_time.on_call_duty' | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>

  <div
    class="work-time-dialog dropdown-menu dropdown-menu-right px-3 shadow-sm"
    *dropdownMenu
    [formGroup]="breakForm"
    [style.minWidth.px]="getMinWidth()"
  >
    <ng-container *ngIf="balanceEnabled && tasStatus == 0">
      <div class="row gutter align-items-center mb-2">
        <div class="col-12 d-flex justify-content-between">
          <span class="text-sm">{{ 'work_time.balance.balance_sum' | translate }}</span>
          <span
            class="text-sm ml-1 current-balance-label"
            >{{
              totalBalance$ | async
                | durationPipe: { type: "m", withSign: true }
            }}</span
          >
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="balanceEnabled && tasStatus > 0">
      <div class="row gutter-xxs align-items-center mb-2">
        <div [ngClass]="((costCentreID$ | async) && costCentreEnabled ) ? 'col card' : 'col-12 card'">

          <div class="row no-gutters  align-items-center indi-row" *ngIf="tasStatus != 2">
              <span class="col-auto indi-label text-sm">{{ 'building.assignment_table.start_date' | translate }}</span>
              <span
                class="col indi-value text-sm"
                >{{
                  startTime$ | async
                    | localizedDate: 'short'
                }}</span
              >
          </div>
          <div class="row no-gutters  align-items-center indi-row">
              <span class="col-auto indi-label text-sm">
              {{ 'work_time.balance.balance_sum' | translate }}
              </span>
              <span
                class="col indi-value text-sm"
               >
                {{
                  totalBalance$ | async
                    | durationPipe: { type: "m", withSign: true }
                }}
                </span>
          </div>
          <div class="row no-gutters  align-items-center indi-row">
              <span class="col-auto indi-label text-sm">{{ 'work_time.balance.balance_current' | translate }}</span>
              <span
                class="col indi-value text-sm"
                >{{
                  currentBalance$ | async
                    | durationPipe: { type: "m", withSign: true }
                }}</span
              >
          </div>
        </div>


        <div class="col card" *ngIf="((costCentreID$ | async) && costCentreEnabled ) ">
          <div class="row no-gutters  align-items-center indi-row">
              <span class="col-auto indi-label text-sm">{{ 'building.assignment_table.start_date' | translate }}</span>
              <span class="col indi-value text-sm"
                >{{
                  costCentreStartTime$ | async
                    | localizedDate: 'short'
                }}</span
              >
          </div>
          <div class="row no-gutters  align-items-center indi-row">
              <span class="col-auto indi-label text-sm">{{ 'invoicing.administration.cost_centre' | translate }}</span>
              <span
                class="col indi-value text-sm"
                >{{
                  costCentreName$ | async
                }}</span
              >
          </div>
          <div class="row no-gutters align-items-center indi-row">
              <span class="col-auto indi-label text-sm">{{ 'work_time.duration' | translate }}</span>
              <span
                class="col indi-value text-sm"
                >{{
                  costCentreDuration$ | async | durationPipe
                }}</span
              >
          </div>
        </div>
      </div>
    </ng-container>
    <div class="row justify-content-between align-conten">
      <ng-container *ngIf="![1, 3].includes(tasStatus)">
        <div class="col text-center">
          <kupari-button
            [type]="'button'"
            [id]="'start_shift'"
            [class]="'btn btn-sm btn-primary'"
            [text]="'work_time.start_shift'"
            (onClick)="startShift()"
          >
          </kupari-button>
        </div>
      </ng-container>
      <ng-container *ngIf="[1].includes(tasStatus)">
        <div class="col text-left">
          <kupari-button
            [type]="'button'"
            [id]="'start_break'"
            [class]="'btn btn-sm btn-primary'"
            [text]="'work_time.start_break'"
            (onClick)="toggleBreakDialog()"
          >
          </kupari-button>
        </div>
        <div class="col text-center" *ngIf="!(costCentreID$ | async) && costCentreEnabled">
          <kupari-button
            [type]="'button'"
            [id]="'start_cost_centre'"
            [class]="'btn btn-sm btn-primary'"
            [text]="'work_time.start_cost_centre'"
            (onClick)="toggleCostCentreDialog()"
          >
          </kupari-button>
        </div>
        <div class="col text-center" *ngIf="(costCentreID$ | async) && costCentreEnabled ">
          <kupari-button
            [type]="'button'"
            [id]="'end_cost_centre'"
            [class]="'btn btn-sm btn-primary'"
            [text]="'work_time.end_cost_centre'"
            (onClick)="toggleCostCentreDialog()"
          >
          </kupari-button>
        </div>
      </ng-container>
      <ng-container *ngIf="[3].includes(tasStatus)">
        <div class="col text-left">
          <kupari-button
            [type]="'button'"
            [id]="'end_break'"
            [class]="'btn btn-sm btn-primary'"
            [text]="'work_time.end_break'"
            (onClick)="toggleBreakDialog()"
          >
          </kupari-button>
        </div>
      </ng-container>
      <ng-container *ngIf="[1, 3].includes(tasStatus)">
        <div class="col text-right">
          <kupari-button
            [type]="'button'"
            [id]="'end_shift'"
            [class]="'btn btn-sm btn-secondary'"
            [text]="'work_time.end_shift'"
            (onClick)="finishShift()"
          >
          </kupari-button>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="showDialog && dialogType == 1" [formGroup]="breakForm">
      <div class="row gutter-xxs align-items-center mb-2">
        <div class="col">
          <span class="text-sm" *ngIf="tasStatus != 3">{{
            "work_time.select_break_type" | translate
          }}</span>
          <span class="text-sm" *ngIf="tasStatus == 3">{{
            "work_time.input_break_explanation" | translate
          }}</span>
        </div>
      </div>

      <div class="row mb-2" *ngIf="tasStatus != 3">
        <div class="col">
          <kupari-select
            formControlName="breakType"
            [items]="breakTypes"
            [bindLabel]="'name'"
            [bindValue]="'id'"
          >
          </kupari-select>
        </div>
      </div>
      <div class="row mb-2 gutter-s" *ngIf="tasStatus == 3">
        <div class="col">
          <kupari-textarea
            formControlName="explanation"
            [label]="'work_time.break_explanation' | translate"
            [placeholder]="'work_time.break_explanation' | translate"
            [autoSize]="false"
            [rows]="3"
            [maxLength]="1000"
            [showCounter]="true"
          >
          </kupari-textarea>
        </div>
      </div>

      <div class="row gutter-xxs">
        <button
          type="button"
          class="col-6 btn btn-sm btn-default border font-weight-600"
          *ngIf="tasStatus != 3"
          (click)="startBreak()"
        >
          <i class="fal fa-check text-primary"></i>
          {{ "work_time.start_break" | translate }}
        </button>

        <button
          type="button"
          class="col-6 btn btn-sm btn-default border font-weight-600"
          *ngIf="tasStatus == 3"
          (click)="finishBreak()"
        >
          <i class="fal fa-check text-primary"></i>
          {{ "work_time.end_break" | translate }}
        </button>

        <button
          type="button"
          class="col-6 btn btn-sm btn-default border font-weight-600"
          (click)="cancelBreak()"
        >
          <i class="fal fa-times text-danger"></i>
          {{ "common.actions.cancel" | translate }}
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="showDialog && dialogType == 2" [formGroup]="costCentreForm">
      <div class="row gutter-xxs align-items-center mb-2">
        <div class="col">
          <span class="text-sm" *ngIf="tasStatus == 1 && !((costCentreID$ | async) && costCentreEnabled )">{{
            "work_time.select_cost_centre" | translate
          }}</span>
          <span class="text-sm" *ngIf="tasStatus == 1 && ((costCentreID$ | async) && costCentreEnabled )">{{
            "work_time.input_cost_centre_explanation" | translate
          }}</span>
        </div>
      </div>

      <div class="row mb-2" *ngIf="tasStatus == 1 && !((costCentreID$ | async) && costCentreEnabled )">
        <div class="col">
          <kupari-select
            formControlName="costCentre"
            [items]="costCentres$ | async"
            [bindLabel]="'name'"
            [bindValue]="'id'"
          >
          </kupari-select>
        </div>
      </div>
      <div class="row mb-2 gutter-s" *ngIf="tasStatus == 1 && ((costCentreID$ | async) && costCentreEnabled )">
        <div class="col">
          <kupari-textarea
            formControlName="costCentreExplanation"
            [label]="'work_time.cost_centre_explanation' | translate"
            [placeholder]="'work_time.input_cost_centre_explanation' | translate"
            [autoSize]="false"
            [rows]="3"
            [maxLength]="1000"
            [showCounter]="true"
          >
          </kupari-textarea>
        </div>
      </div>

      <div class="row gutter-xxs">
        <button
          type="button"
          class="col-6 btn btn-sm btn-default border font-weight-600"
          *ngIf="tasStatus == 1 && !((costCentreID$ | async) && costCentreEnabled )"
          (click)="startCostCentre()"
        >
          <i class="fal fa-check text-primary"></i>
          {{ "work_time.start_cost_centre" | translate }}
        </button>

        <button
          type="button"
          class="col-6 btn btn-sm btn-default border font-weight-600"
          *ngIf="tasStatus == 1 && ((costCentreID$ | async) && costCentreEnabled )"
          (click)="finishCostCentre()"
        >
          <i class="fal fa-check text-primary"></i>
          {{ "work_time.end_cost_centre" | translate }}
        </button>

        <button
          type="button"
          class="col-6 btn btn-sm btn-default border font-weight-600"
          (click)="cancelCostCentre()"
        >
          <i class="fal fa-times text-danger"></i>
          {{ "common.actions.cancel" | translate }}
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="showDialog && dialogType == 3" [formGroup]="shiftForm">
      <div class="row gutter-xxs align-items-center mb-2">
        <div class="col">
          <span class="text-sm" *ngIf="tasStatus == 0">{{
            "work_time.confirmation.work_shift_start" | translate
          }}</span>
          <span class="text-sm" *ngIf="tasStatus > 0">{{
            "work_time.confirmation.work_shift_end" | translate
          }}</span>
        </div>
      </div>

      <div class="row mb-2 gutter-s">
        <div class="col-12"
            *ngIf="tasStatus == 0" >
          <kupari-textarea
            formControlName="explanationForStartTime"
            [label]="'work_time.explanation_for_starttime' | translate"
            [placeholder]="'work_time.explanation_for_starttime' | translate"
            [autoSize]="false"
            [rows]="3"
            [maxLength]="1000"
            [showCounter]="true"
          >
          </kupari-textarea>
        </div>
        <div class="col-12"
            *ngIf="tasStatus > 0" >
          <kupari-textarea
            *ngIf="tasStatus > 0"
            formControlName="explanationForEndTime"
            [label]="'work_time.explanation_for_endtime' | translate"
            [placeholder]="'work_time.explanation_for_endtime' | translate"
            [autoSize]="false"
            [rows]="3"
            [maxLength]="1000"
            [showCounter]="true"
          >
          </kupari-textarea>
        </div>
      </div>

      <div class="row gutter-xxs">
        <button
          type="button"
          class="col-6 btn btn-sm btn-default border font-weight-600"
          *ngIf="tasStatus == 0"
          (click)="startShift()"
        >
          <i class="fal fa-check text-primary"></i>
          {{ "work_time.start_shift" | translate }}
        </button>

        <button
          type="button"
          class="col-6 btn btn-sm btn-default border font-weight-600"
          *ngIf="tasStatus > 0"
          (click)="finishShift()"
        >
          <i class="fal fa-check text-primary"></i>
          {{ "work_time.end_shift" | translate }}
        </button>

        <button
          type="button"
          class="col-6 btn btn-sm btn-default border font-weight-600"
          (click)="cancelShift()"
        >
          <i class="fal fa-times text-danger"></i>
          {{ "common.actions.cancel" | translate }}
        </button>
      </div>
    </ng-container>
  </div>
</div>
